import React from 'react';
import { useTranslation } from 'react-i18next';

import { pages } from '@/settings/pages';
import { PasswordEditFormContainer } from '@/components/pages/Account/PasswordEdit/PasswordEditForm';
import { PageRootWrapper } from '@/components/shared/PageRootWrapper';

export const AccountPasswordEditPage: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.account.password.edit.title');

  return (
    <PageRootWrapper
      title={title}
      headerTitle={title}
      hasHeaderDivider={true}
      breadcrumbItems={[
        {
          label: t('pages.account.index.title'),
          path: pages.account.index,
        },
        { label: title },
      ]}
      containerType="normal"
    >
      <PasswordEditFormContainer />
    </PageRootWrapper>
  );
};
